// 🏡💡 The picture allowance, the page's side (PORTED_HOME_HANDOFF_2026_09_25
// §3 rulings 30 + 31, "E2"; Nina 09-26: "an ambient take on a battery",
// "four cyan lights circle his circle", ONE shared meter, guests dim his
// lights too). The status of a ported room carries
//   pictures: { left, per_day, refills_at }
// counted on the server from the room's own rows inside the owner's day (never
// a stored counter). This module turns that block into what the page shows:
// his four lights (the light room and the painted home), the caption's plain
// line, and the composer's "N left today" on /imagine /build /scene.
//
// PURE on purpose (the crowdInline.js pattern): no React, no DOM, no clock.
// An older backend serves no `pictures`: every helper answers null / '' and
// the page draws nothing for it (no lights, no line, no hint).

// The picture verbs, as the composer names them (the server's list is
// build + combine + imagine, and a scene only while it gets its picture).
export const PICTURE_COMMANDS = ['imagine', 'build', 'scene'];
// Player copy (Nina 09-26, batch H): short, plain, no em dashes.
export const LIGHTS_OUT = 'The lights are out for today. They come back at midnight.';
export const SCENE_NO_PICTURE = 'The lights are out. The scene lands without a picture.';
export const LIGHTS_MAX = 8;

const int = (v) => (Number.isFinite(Number(v)) ? Math.floor(Number(v)) : NaN);

/** The status block → { left, perDay }, or null when the room has no meter (an older backend). */
export function lightsFor(pictures) {
  if (!pictures || typeof pictures !== 'object') return null;
  const perDay = int(pictures.per_day);
  const left = int(pictures.left);
  if (!Number.isFinite(perDay) || perDay < 1 || !Number.isFinite(left)) return null;
  const of = Math.min(LIGHTS_MAX, perDay);
  return { left: Math.max(0, Math.min(of, left)), perDay: of };
}

export const isPictureCommand = (name) => PICTURE_COMMANDS.includes(String(name || '').toLowerCase());

/** The caption's plain line under the mood ("4 pictures left today"), '' with no meter. */
export function picturesLine(pictures) {
  const l = lightsFor(pictures);
  if (!l) return '';
  if (l.left === 0) return LIGHTS_OUT;
  return `${l.left} picture${l.left === 1 ? '' : 's'} left today`;
}

/** The composer's hint on a picture verb ("2 left today"), '' for any other verb or no meter. */
export function picturesHint(pictures, commandName) {
  const l = lightsFor(pictures);
  if (!l || !isPictureCommand(commandName)) return '';
  if (l.left === 0) return String(commandName).toLowerCase() === 'scene' ? SCENE_NO_PICTURE : LIGHTS_OUT;
  return `${l.left} left today`;
}

/** A short label for the lights themselves (aria): "3 of 4 pictures left today". */
export function lightsLabel(pictures) {
  const l = lightsFor(pictures);
  if (!l) return '';
  return `${l.left} of ${l.perDay} pictures left today`;
}
